import React from 'react';
import ReactDOM from 'react-dom';

import ContainerTitleLogoTextLinks from '../Containers/ContainerTitleLogoTextLinks'

const titlelogoText = document.getElementsByClassName('titlelogotext')
for (let i = 0; i < titlelogoText.length; i++) {
	const dataTabs = JSON.parse(titlelogoText[i].getAttribute('data-info'))

	ReactDOM.render(<ContainerTitleLogoTextLinks {...dataTabs} />,titlelogoText[i])
}


// WEBPACK FOOTER //
// ./src/build/titlelogotext.js